import { render, staticRenderFns } from "./VendorDashboard.vue?vue&type=template&id=5731bd4e&scoped=true&"
import script from "./VendorDashboard.vue?vue&type=script&lang=js&"
export * from "./VendorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./VendorDashboard.vue?vue&type=style&index=0&id=5731bd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731bd4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
